import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Container,
  Wrapper,
  Image,
  Title,
  SpacerLine,
  ContinueButton,
} from './elements';

import { useText, useConfig } from 'common/hooks';

const deps = {
  oobError: state.account.oobError,
  continueFromConfirmEmail: sequences`account.continueFromConfirmEmail`,
};

export function VerifyConfirmEmail({
  oobError,
  continueFromConfirmEmail,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  if (oobError)
    return (
      <Container>
        <Wrapper>
          <Image alt={''} src={`${staticUrl}/images/sad_earth.png`} />
          <Title as={'h1'}>
            {t('authentication.errors.invalid_action_code')}
          </Title>
          <ContinueButton href="/register">
            {t('authentication.resend')}
          </ContinueButton>
        </Wrapper>
      </Container>
    );

  return (
    <Container>
      <Wrapper>
        <Image alt={''} src={`${staticUrl}/images/foam_finger.svg`} />
        <Title as={'h1'}>{t('authentication.email_confirmed')}</Title>
        <SpacerLine />
        <ContinueButton onClick={() => continueFromConfirmEmail()}>
          {t('authentication.continue')}
        </ContinueButton>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, VerifyConfirmEmail);
